// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetGrantStatus,DownloadGrant } from '@api';

export const getGrantStatus = createAsyncThunk('extractionofgrant/getGrantStatus', async args => {

  const response = await GetGrantStatus(args);
  return response.data;
});

export const downloadGrant = createAsyncThunk('extractionofgrant/downloadGrant', async args => {

  const response = await DownloadGrant(args);
  return response.data;
});


export const extractionOfGrantSlice = createSlice({
  name: 'extractionofgrant',
  initialState: {
    isDownloadable: false,
    processedDate: "",
    caseNo: ""
  },
  reducers: {
    handleFeePaid: (state, action) => {
      state.feePaid = action.payload
      // state[config.storageTokenKeyName] = action.payload[config.storageTokenKeyName]
      // state[config.storageRefreshTokenKeyName] = action.payload[config.storageRefreshTokenKeyName]
      // localStorage.setItem('userData', JSON.stringify(action.payload))
      // localStorage.setItem(config.storageTokenKeyName, JSON.stringify(action.payload.accessToken))
      // localStorage.setItem(config.storageRefreshTokenKeyName, JSON.stringify(action.payload.refreshToken))
    },
    setPaymentDetails: (state, action) => {
      state.paymentDetails = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getGrantStatus.fulfilled, (state, action) => {
        state.processedDate = action.payload.ProcessedDate;
        state.caseNo = action.payload.CaseNo;
        state.isDownloadable = action.payload.IsDownloadable;

      })

  }

})


export const { handleFeePaid, setPaymentDetails } = extractionOfGrantSlice.actions
export default extractionOfGrantSlice.reducer

